export enum AuthorizationRoles {
  admin = 'admin',
  casApprover = 'cas-approver',
  casReconciler = 'cas-reconciler',
  cmsReporter = 'cms-reporter',
  cmsSupport = 'cms-support',
  cmsPortalAdmin = 'cms-portal-admin',
  cmsComplianceMgr = 'cms-compliance-manager',
  umcSuperUser = 'umc-super-user',
}

export enum AuthRolesDisplayValue {
  admin = 'Admin',
  cmsPortalAdmin = 'Portal Admin',
  cmsReporter = 'Reporter',
  cmsSupport = 'Support Agent',
  casApprover = 'CAS Approver',
  casReconciler = 'CAS Reconciler',
  cmsComplianceMgr = 'Compliance Manager',
  umcSuperUser = 'Super User',
}

export enum AuthPermissions {
  Everyone = 'Everyone',
  accountingMethodsRead = 'accounting.methods:read',
  customerFormRead = 'customer.form:read',
  customerFormWrite = 'customer.form:write',
  customerPiiRead = 'customer:pii:read',
  customerRead = 'customer:read',
  customerWrite = 'customer:write',
  enterpriseSpa = 'enterprise-spa',
  journalEntryRead = 'journal.entry:read',
  journalEntryWrite = 'journal.entry:write',
  legacyWrite = 'legacy:write',
  reconciliationWrite = 'reconciliation:write',
  reconciliationRead = 'reconciliation:read',
  reportsRead = 'reports:read',
  reportsWrite = 'reports:write',
  tenantRead = 'tenant:read',
  tenantWrite = 'tenant:write',
  userRead = 'user:read',
  userWrite = 'user:write',
}
